<template>
  <table>
    <tbody>
      <tr v-for="(extra, index) of extras" :key="index">
        <td>
          {{ extra.name }}
          <extra-description
            :extra-description="extra.description"
            :extra-terms="extra.terms"
          />
        </td>
        <td class="right">
          <pu-price :price="extra.price" :display-original-price="true" />
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script lang="ts">
import { Component, Prop, Vue, toNative } from '~/utility/pu-class-decorator'
import { Extra } from '../../../apps/booking/schema'

@Component
class CompulsoryExtras extends Vue {
  @Prop()
  extras: Extra[]
}

export default toNative(CompulsoryExtras)
</script>
<style scoped>
table tr td:last-of-type {
  text-align: right;
}
</style>
